import UnstyledButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const Button = styled(UnstyledButton)(({ theme }) => ({
  borderColor: theme.palette.primary.main,
  borderRadius: 8,
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightBold,
}));
